<template>
  <div>
    <!-- 工作台路由配置 -->
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'formflowWorkIndex',
  data () {
    return {
    }
  }
}
</script>
<style></style>
